export const subscriptionMixin = {

    //********************* SUBSCRIBE TO CONVERSATION ********************************//
    // Subscribes to live '/ws/emit-to-user' pushes addressed to the active user, so
    // new messages arrive without polling. The push's 'user_id' destination is always
    // the recipient (us), so handleEmitToUser filters by conversation_id itself.
    subscribeToConversation() {
        gudhub.on('gudhub_messenger', { user_id: this.activeUserId }, this.handleEmitToUser);
    },

    //********************* UNSUBSCRIBE FROM CONVERSATION ********************************//
    // Removes the subscription added by subscribeToConversation(), if any.
    unsubscribeFromConversation() {
        if(this.conversationId) {
            gudhub.destroy('gudhub_messenger', { user_id: this.activeUserId }, this.handleEmitToUser);
        }
    },

    //********************* HANDLE EMIT TO USER ********************************//
    // Appends a message pushed via '/ws/emit-to-user' to the active conversation,
    // skipping anything already shown (e.g. replayed from the pipe message box)
    // or belonging to a different conversation than the one currently open.
    // Also handles reaction_added/reaction_removed pushes (see toggleReaction),
    // updating the affected message's reaction pills in place.
    // * error (null) — unused, part of the pipeService callback signature
    // * data (Object) — { conversation_id, message } | { conversation_id, event, message_id, reactions } payload
    handleEmitToUser(error, data) {
        if(data.conversation_id !== this.conversationId) return;

        if(data.event === 'reaction_added' || data.event === 'reaction_removed') {
            const message = this.findMessageById(data.message_id);
            if(message) message.reactions = data.reactions;

            this.updateMessageReactions(data.message_id, data.reactions);
            return;
        }

        if(!data.message) return;

        const messages = this.activeMessages();

        if(messages.some(message => message.message_id === data.message.message_id)) return;

        const message = this.normalizeMessage(data.message);
        messages.push(message);

        this.prefetchParticipants([message.user_id]).then(() => {
            this.addMessageToConversation(message);
            this.scrollChatToBottom();
            this.markAsRead();
        });
    },
};
